import { evaluateSync } from '@mdx-js/mdx';
import { ComponentProps, useMemo } from 'react';
import * as runtime from 'react/jsx-runtime';
import { RecommendedCarousel } from '@/entities/product/ui/recommended-carousel';
import { cn } from '@/shared/lib/cn';
import { BlogCard } from '@/widgets/blog';
import { BlogCTABar } from '@/widgets/blog';

const parseContent = (content: string) => {
    return content.replace(/style="([^"]*)"/gu, (match, styleString) => {
        const styles = styleString
            .split(';')
            .filter((rule: string) => rule.trim())
            .map((rule: string) => {
                const [property, value] = rule.split(':').map((s) => s.trim());
                if (!property || !value) {
                    return '';
                }

                const camelProperty = property.replace(/-([a-z])/gu, (_: string, letter: string) =>
                    letter.toUpperCase(),
                );

                return `${camelProperty}: "${value}"`;
            })
            .filter(Boolean)
            .join(', ');

        return styles ? `style={{${styles}}}` : '';
    });
};

const useMDX = (content: string) => {
    const exports = useMemo(
        () =>
            evaluateSync(content, {
                ...runtime,
                // useMDXComponents: () => mdxComponents,
            }),
        [content],
    );

    return exports;
};

type Props = {
    content: string;
};

export const ClientMDXRenderer = ({ content }: Props) => {
    const exports = useMDX(parseContent(content));
    const Content = exports.default;

    return (
        <Content
            components={{
                BlogCTABar: ({ isCTAWithBorder }) => (
                    <BlogCTABar
                        className={cn('blog-detail__cta', isCTAWithBorder && 'blog-detail__cta--with-border')}
                    />
                ),
                RecommendedCarousel: ({ posts }: { posts: ComponentProps<typeof BlogCard>[] }) => (
                    <RecommendedCarousel className="blog-detail__carousel">
                        {posts.map((post) => (
                            <BlogCard className="blog-detail__blog-card" key={post.id} {...post} />
                        ))}
                    </RecommendedCarousel>
                ),
            }}
        />
    );
};
